import React from "react";

const SeventhSection = () => {
  return (
    <div className="bg-[#181728] text-white flex flex-col lg:flex-row items-center justify-center py-10 px-6 md:px-12 lg:px-[180px] text-[10px] gap-10 lg:gap-20">
      {/* Review Card 1 */}
      <div className="flex flex-col lg:flex-row justify-center items-center gap-4 w-full lg:w-auto">
        <div>
          <div className="rounded-full w-[60px] md:w-[80px] h-[60px] md:h-[80px] bg-white"></div>
        </div>
        <div className="flex flex-col justify-center gap-2 text-center lg:text-left">
          <p className="text-sm md:text-base">
            KhmerGate made our trip to Cambodia absolutely unforgettable! The
            tours were so well organized, and the local guides truly made the
            experience special.
          </p>
          <p className="font-semibold text-sm md:text-base">-S. Johnson, USA</p>
          <div className="bg-white h-[1px] w-full"></div>
        </div>
      </div>

      {/* Review Card 2 */}
      <div className="flex flex-col lg:flex-row justify-center items-center gap-4 w-full lg:w-auto">
        <div>
          <div className="rounded-full w-[60px] md:w-[80px] h-[60px] md:h-[80px] bg-white"></div>
        </div>
        <div className="flex flex-col justify-center gap-2 text-center lg:text-left">
          <p className="text-sm md:text-base">
            KhmerGate made our trip to Cambodia absolutely unforgettable! The
            tours were so well organized, and the local guides truly made the
            experience special.
          </p>
          <p className="font-semibold text-sm md:text-base">-S. Johnson, USA</p>
          <div className="bg-white h-[1px] w-full"></div>
        </div>
      </div>

      {/* Review Card 3 */}
      <div className="flex flex-col lg:flex-row justify-center items-center gap-4 w-full lg:w-auto">
        <div>
          <div className="rounded-full w-[60px] md:w-[80px] h-[60px] md:h-[80px] bg-white"></div>
        </div>
        <div className="flex flex-col justify-center gap-2 text-center lg:text-left">
          <p className="text-sm md:text-base">
            KhmerGate made our trip to Cambodia absolutely unforgettable! The
            tours were so well organized, and the local guides truly made the
            experience special.
          </p>
          <p className="font-semibold text-sm md:text-base">-S. Johnson, USA</p>
          <div className="bg-white h-[1px] w-full"></div>
        </div>
      </div>
    </div>
  );
};

export default SeventhSection;
